import { Alert, Button, Radio } from 'antd';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Modal from '../../../foundation/components/modal/Modal';
import { useVariantAccess } from '../hooks/useVariantAccess';
import { selectVariantLock } from '../redux';
import { VariantProbandReportData } from '../redux';

export type MedicalInvestigationSelectModalProps = {
  open: boolean;
  onCancel: () => void;
  reportDataList: VariantProbandReportData[];
  onConfirm: (medicalinvestigation_id: number) => void;
};

const MedicalInvestigationSelectModal: React.FC<
  MedicalInvestigationSelectModalProps
> = ({ open, onCancel, reportDataList, onConfirm }) => {
  const { isReadOnly, canInteract } = useVariantAccess();
  const lock = useSelector(selectVariantLock);
  const options = useMemo(
    () =>
      (reportDataList || []).map((r) => ({
        label: r.medicalinvestigation_name,
        value: r.medicalinvestigation_id,
      })),
    [reportDataList],
  );

  const [selected, setSelected] = useState<number | undefined>(
    reportDataList?.[0]?.medicalinvestigation_id,
  );

  const handleOk = () => {
    if (selected != null) {
      onConfirm(selected);
    }
  };

  return (
    <Modal
      title="Select medical investigation"
      open={open}
      onCancel={onCancel}
      closable
      footer={null}
      maskClosable={false}
      centered
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {isReadOnly && lock && (
          <Alert
            message="Read-Only Mode"
            description={`This variant is currently locked by ${lock.locked_by} and cannot be edited.`}
            type="warning"
            showIcon
          />
        )}

        <Radio.Group
          options={options}
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleOk}
            disabled={selected == null || !canInteract}
          >
            Generate report
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MedicalInvestigationSelectModal;
